var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPii = function SvgPii(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "PI Icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2927"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 114",
    cx: 18.821,
    cy: 18.326,
    rx: 18.821,
    ry: 18.326,
    transform: "translate(12.066 3.395)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 10",
    d: "M30.888 76.606c-7.427 0-14.477-1.5-19.851-4.225-5.355-2.715-8.509-6.369-8.883-10.286h-.04c0-.181 0-.349.008-.5-.008-.1-.008-.195-.008-.29a8.316 8.316 0 0 1 .181-1.71 18.024 18.024 0 0 1 1.591-5.193 20.916 20.916 0 0 1 3.172-4.762 28.466 28.466 0 0 1 12.732-8.045 23.1 23.1 0 0 0 11.1 2.728 23.091 23.091 0 0 0 11.099-2.728c.9.29 1.784.618 2.635.975a16.8 16.8 0 0 0-.215 2.681 16.568 16.568 0 0 0 4.423 11.29 16.562 16.562 0 0 0 10.827 5.275v.276h-.035c-.374 3.919-3.53 7.573-8.884 10.288-5.374 2.726-12.426 4.226-19.852 4.226Zm22.194-27.04a3.576 3.576 0 0 1-2.709-.837 4.838 4.838 0 0 1-.979-3.477v-.17a25.748 25.748 0 0 1 5.185 4.4 15.54 15.54 0 0 1-1.497.084Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 11",
    d: "M62.376 59.098a15.491 15.491 0 0 1-10.951-26.445 15.49 15.49 0 1 1 21.906 21.906 15.394 15.394 0 0 1-10.955 4.539Zm-5.707-16.419a2.684 2.684 0 0 0-1.618 4.83l6.575 4.955 8.611-11.461a2.686 2.686 0 0 0-4.292-3.23l-5.382 7.163-2.283-1.72a2.659 2.659 0 0 0-1.611-.537Z",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10
  })))));
};
export default SvgPii;